import { RadioOption } from '@infoods/lifebase-ui';

import { validateNegativeNumber } from '../../shared/utils/reactHookFormUtils';

export const MEALS_PER_DAY_OPTIONS: RadioOption[] = [
  { label: '3 Meals & 3 Snacks', value: 6 },
  { label: '3 Meals & 2 Snacks', value: 5 },
];

export const MACRO_NUTRIENT_HINTS = {
  proteins: 7,
  carbs: 15,
  fats: 5,
} as const;

export const MEAL_PLANS_LIMIT = 20;

export const MACRO_INPUT_RULES = {
  required: 'required, set at least 0',
  validate: { validateNegativeNumber },
};
